import type { Project } from '../types/project.types'

/**
 * Resolves workspace-scoped project list and currentProject after fetching all user projects.
 * Keeps an optimistic currentProject when the API list has not caught up yet.
 */
export function resolveProjectsStateAfterWorkspaceFetch(
  allProjects: Project[],
  targetWorkspaceId: string,
  currentProject: Project | null
): { projects: Project[]; currentProject: Project | null } {
  const filtered = allProjects.filter((project) => project.workspaceId === targetWorkspaceId)
  const currentBelongsToWorkspace = currentProject?.workspaceId === targetWorkspaceId

  if (currentBelongsToWorkspace && currentProject) {
    const fromList = filtered.find((project) => project.id === currentProject.id)

    if (fromList) {
      return { projects: filtered, currentProject: fromList }
    }

    return { projects: [...filtered, currentProject], currentProject }
  }

  const shouldKeepCurrentProject = filtered.some((project) => project.id === currentProject?.id)

  return {
    projects: filtered,
    currentProject: shouldKeepCurrentProject ? currentProject : null,
  }
}
